import { Navigate } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";

const ProtectedRoute = ({ children }) => {
  const { user, loading } = useAuth()
  
  if (!loading && !user) {
    return <Navigate to="/" replace />;
  }

  return children;
};

export default ProtectedRoute;